'use strict';



//import $ from 'jquery';
//window.$ = window.jQuery = $;
/*
window.Vue = require('vue');
require ('vue-template-compiler');
window.VueRouter = require ('vue-router')
Vue.use(VueRouter);*/

require ('v-calendar');
window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});

require ("../timedropper-master/timedropper.min.js")
// Variations that I tried - one at a time
require ('materialize-css');
const login = require ('./login');
const createProspect = require ('./createProspect');
const viewProspect = require ('./viewProspect');
const commentsProspects = require ('./commentsProspects');
const pagination = require ('./pagination');
const createClient = require ('./createClient');
require ('./client/update_photo');
require ('./client/update');
require ('./client/contract');
const appStore = require ('./appStore');
require ('./serchInput');
require ('./menu');
require ('./calendar-date-picker/jquery.calendar');
require ('./calendar');

require('../DataTables/datatables.min.js');
require('../js/serchDatatable.js');

require('./contact.js');
require('./documentacion.js');

require('./fTrabajo.js');

require('./createUser.js');
require('./updateUser.js');

//import calendar from './components/calendar';
//Vue.component(calendar);
//window.calendar=calendar;

window.Lightpick =require ('lightpick');



import swal from 'sweetalert';
//importarScript("js/swal.js");
var contLogin,campo,emailRegex;

function importarScript(nombre) {
    var s = document.createElement("script");
    s.src = https + nombre;
    document.querySelector("head").appendChild(s);
}

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
        },0);
    }
    window.load = cargar();
    $('.modal').modal();
    $('.modalNota').modal();
    $('.sidenav').sidenav();
    $('.dropdown-trigger').dropdown({
        hover: true
    });
    $('.tabs').tabs();
    $('select').formSelect();
    $('.datepicker').datepicker({
        selectMonths: true, // Creates a dropdown to control month
        yearRange: 2, // Creates a dropdown of 15 years to control year,
        format: 'dd/mm/yyyy',
        i18n: {
            clear: 'Limpiar',
            cancel: 'Cancelar',
            done: 'Guardar',
            labelMonthNext: 'Próximo Mes',
            labelMonthPrev: 'Mes Anterior',
            months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            weekdaysFull: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
            weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
            weekdaysLetter: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        },
        closeOnSelect: true // Close upon selecting a date,
    });
    $('.timepicker').timepicker({
        i18n: {
            clear: 'Limpiar',
            cancel: 'Cancelar',
            done: 'Guardar',
        },
    });
});


$('.close-menu').click(function () {
    $('.sidenav').sidenav('close');
});

$('#selectDashboardAdmin').change(function () {
    if(this.value == 'clientes'){
        location.href = https + 'dashboard'
    }else if(this.value == 'prospectos'){
        location.href = https + 'prospectos'
    }
});

$('.openProspects').click(function () {
    location.href = https + 'prospect/view/p-'+this.id+'/gestion';
});

$('.openUsers').click(function () {
    location.href = https + 'users/view/'+this.id;
});